import { BookingServiceClient } from 'fitbeat.api-clients';
import { AreaCategory, UserWorkoutSession, staticMachineAreaZones } from 'fitbeat.gym-core';
import { GymTypes } from 'fitbeat.models';
import React, { FunctionComponent, useEffect } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import { getOpenInviteClassList } from '../../Bookings';
import { isBookingForGroupWorkout } from '../../Bookings/utils/BookingUtils';
import { Avatar } from '../../components';
import { getApiConfig } from '../../config';
import { GymResolver } from '../../services';
import Theme from '../../theme';
import { friendsJoiningText } from '../../utils';
import { AuthTokenBuilder } from '../../utils/authTokenBuilder';
import { getSlotTime } from '../../utils/getSlotTime';
import { defaultScale } from '../../utils/scaling';
import { getAreaIcon } from '../../utils/areaCategoryMapping';
import { avatarSize, getBookingTime, iconsMapLight, plannerStyles } from './planner-shared-styles';

interface IProps {
  booking: UserWorkoutSession;
  openInviteClass: any;
  fetchBookingClassList: (bookingId: string) => any;
  t: (key: string, params?: any) => string;
  onPress: (booking: any) => void;
  itemIndex: number;
  isInvite?: boolean;
  areaCategory: AreaCategory
}

export const WorkoutBookingComponent: FunctionComponent<IProps> = (
  {
    booking,
    openInviteClass,
    fetchBookingClassList,
    onPress,
    t,
    itemIndex,
    isInvite = false,
  },
) => {
  useEffect(() => {
    if (isBookingForGroupWorkout(booking)) {
      fetchBookingClassList(booking.uniqueReference);
    }
  }, []);

  const isStudioWorkout = () => GymResolver.getByName(booking.gymName).type !== GymTypes.Home;

  const friendsJoining = friendsJoiningText(openInviteClass, booking.userProfileId, isStudioWorkout(), t, isInvite);

  const textColorStyle = {
    color: isInvite ? Theme.GREY_DARK : Theme.WHITE,
  };

  const getWorkoutIcon = () => {
    if (isStudioWorkout()) {
      return booking.areaCategory
        ? getAreaIcon(booking.areaCategory, Theme.WHITE)
        : iconsMapLight[booking.settings.cardioOrResistance]
    }

    return getAreaIcon('home', Theme.WHITE)
  }

  return (
    <TouchableOpacity onPress={() => onPress(booking)}
      style={[
        plannerStyles.plannerEntry,
        isInvite ? plannerStyles.unConfirmedEntry : plannerStyles.confirmedEntry,
        itemIndex ? plannerStyles.secondCardOnwards : plannerStyles.firstCard,
      ]}>
      {!isInvite &&
        <View style={styles.iconContainer}>
          {getWorkoutIcon()}
        </View>
      }
      <View style={styles.detailContainer}>
        <Text style={[styles.dateTimeText, textColorStyle]}>
          {`${getBookingTime(booking)}  |  ${getSlotTime(booking, !isStudioWorkout())}`}
        </Text>
        {!!friendsJoining &&
          <Text style={[styles.subText, textColorStyle]}>
            {friendsJoining}
          </Text>
        }
        {isStudioWorkout() &&
          <Text style={[styles.subText, textColorStyle]}>@ {GymResolver.getByName(booking.gymName).displayName}</Text>
        }
      </View>
      {isInvite &&
        <View>
          <Avatar
            size={avatarSize}
            customStyle={{
              width: avatarSize,
              height: avatarSize,
              borderRadius: avatarSize / 2,
              borderWidth: 0,
            }}
            avatarId={booking.pairedSessionUserProfileId}
            showIcon={false}
          />
        </View>
      }
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  detailContainer: {
    flex: 1,
    justifyContent: 'center',
    paddingLeft: defaultScale(5),
  },
  iconContainer: {
    justifyContent: 'center',
    paddingRight: defaultScale(10),
  },
  dateTimeText: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    textTransform: 'lowercase',
  },
  subText: {
    ...Theme.textStyle.bodyCopyReg,
    marginTop: defaultScale(3),
    color: Theme.WHITE,
  },
});

const mapStateToProps = (state, ownProps) => {
  const { openInviteClassesByWorkoutId } = state.bookings.bookings;
  const openInviteClass = openInviteClassesByWorkoutId[ownProps.booking.uniqueReference];
  return {
    openInviteClass,
  };
};

const mapDispatchToProps = (dispatch) => {
  const bookingServiceClient = new BookingServiceClient(getApiConfig(), fetch, new AuthTokenBuilder());
  return {
    fetchBookingClassList: (workoutId) =>
      dispatch(getOpenInviteClassList(bookingServiceClient, workoutId, true)),
  };
};

export const WorkoutBooking = connect(mapStateToProps, mapDispatchToProps)(WorkoutBookingComponent);
